import React from 'react';
import { useCurrentUser, useSearchSelector, useTranslate } from '@hooks';
import { camelCase } from 'lodash';
import { toDate } from '@dotone/react-ui-core/utils';
import { marketplaceCurrentStatuses as statuses } from '@constants';
import { Badge, BasicPopover, Text, FlexContainer } from '@dotone/react-ui-core';
import InviteFormModal from './MarketplaceInviteFormModal';

const colors = {
  [statuses.ACTIVE]: 'success',
  [statuses.PENDING]: 'secondary',
};

const MarketplaceInviteAction = ({ affiliate, offerId, buttonProps = {} }) => {
  const { t } = useTranslate('marketplace', 'inviteStatus');
  const { t: tHint } = useTranslate('marketplace', 'hints');
  const { currentUser, locale } = useCurrentUser();
  const { id, canInvite, inviteStatus, inviteRelatedDate } = affiliate;

  const { data: offers } = useSearchSelector(({ offerSearch }) => offerSearch, {
    activePublic: true,
    locale,
  });
  const offer = offers.find((o) => o.id === offerId);

  const tStatusKey = camelCase(inviteStatus);
  const target = `invite-action-${id}`;

  return (
    <>
      <BasicPopover
        target={target}
        content={tHint(`${tStatusKey}.content`, {
          offer: offer?.name,
        })}
      />
      {[statuses.ACTIVE, statuses.PENDING].includes(inviteStatus) ? (
        <FlexContainer column align="center">
          <Badge
            color={colors[inviteStatus]}
            className="text-rg px-3 py-2"
            style={{ width: 160 }}
            id={target}
          >
            {t(tStatusKey)}
          </Badge>
          {inviteRelatedDate && (
            <Text muted size="sm">
              {tHint(`date.${camelCase(tStatusKey)}`, { date: toDate(inviteRelatedDate) })}
            </Text>
          )}
        </FlexContainer>
      ) : (
        <InviteFormModal
          defaultValues={{ affiliateId: id, offerId }}
          buttonProps={{
            style: { width: 160 },
            disabled: currentUser.marketplaceInvitesAvailable <= 0 || !canInvite,
            id: target,
            children: t(tStatusKey),
            ...buttonProps,
          }}
        />
      )}
    </>
  );
};

export default MarketplaceInviteAction;
